import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_ADD_USER_BOOKMARK } from 'api/actionTypes';

import { DATA_TABLE_SOURCE_USER_BOOKMARKS } from 'common/dataTableConstants';

import { actionDataTableReset } from 'client/helpers/dataTables';

import askForMobileAppReview from 'client/actions/MobileApp/askForReview';

export default async function addBookmark({ state, apiClient }, { listingId, userId }) {
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('userId::Maybe PositiveNumber', userId);

  if (!state.exists(['bookmarksByListingId', listingId])) {
    const newBookmarksByListingId = {
      ...state.get(['bookmarksByListingId']),
      [listingId]: true,
    };
    state.set(['bookmarksByListingId'], newBookmarksByListingId);
    state.apply(['newBookmarksCount'], (count) => count + 1);
    state.commit();

    await apiClient.postWithState({
      action: SR_API_ACTION_ADD_USER_BOOKMARK,
      state: state,
      payload: {
        listingId,
        userId: userId || state.get(['currentUser', 'id']),
      },
      onSuccess() {
        if (Object.keys(newBookmarksByListingId).length === 5) {
          askForMobileAppReview({ state });
        }
      },
    });
  }

  return actionDataTableReset(
    { state, apiClient },
    {
      dataSource: DATA_TABLE_SOURCE_USER_BOOKMARKS,
    },
  );
}
